export { default } from './getInitials'
